// Saved CMAs (drafts and finals). Stored per agent at cmaDrafts/{ownerUid}/{id} so agents read only
// their own and admins can read the whole cmaDrafts path. Rules for this path are drafted in
// database.rules.cmaDrafts.DRAFT.json and are NOT deployed yet.
import { ref, push, set, update, remove, onValue } from 'firebase/database';
import { database } from '../firebaseConfig';

export const CMA_DRAFTS = 'cmaDrafts';
export const normEmail = (e) => String(e || '').trim().toLowerCase();
export const normPhone = (p) => String(p || '').replace(/\D/g, '').slice(-10);

// The client a CMA belongs to: any linked record ids plus email/phone for matching elsewhere.
export const clientLinks = ({ contactId, sellerInterestId, buyerInterestId, transactionId, email, phone, name } = {}) => {
  const out = {};
  if (contactId) out.contactId = contactId;
  if (sellerInterestId) out.sellerInterestId = sellerInterestId;
  if (buyerInterestId) out.buyerInterestId = buyerInterestId;
  if (transactionId) out.transactionId = transactionId;
  if (normEmail(email)) out.email = normEmail(email);
  if (normPhone(phone).length === 10) out.phone = normPhone(phone);
  if (name) out.name = String(name).trim();
  return out;
};

// True when a saved CMA belongs to the person described by `who` (same ids, email or phone).
export const cmaMatches = (draft, who = {}) => {
  const c = (draft && draft.client) || {};
  if (!who) return false;
  if (who.contactId && c.contactId === who.contactId) return true;
  if (who.sellerInterestId && c.sellerInterestId === who.sellerInterestId) return true;
  if (who.buyerInterestId && c.buyerInterestId === who.buyerInterestId) return true;
  if (who.transactionId && c.transactionId === who.transactionId) return true;
  const e = normEmail(who.email); if (e && c.email === e) return true;
  const p = normPhone(who.phone); if (p.length === 10 && c.phone === p) return true;
  return false;
};

export const saveCmaDraft = async (uid, id, data) => {
  const now = Date.now();
  // JSON round-trip drops undefined values, which Firebase rejects.
  const body = { ...JSON.parse(JSON.stringify(data)), ownerUid: uid, updatedAt: now, status: data.status === 'final' ? 'final' : 'draft' };
  if (id) { await update(ref(database, `${CMA_DRAFTS}/${uid}/${id}`), body); return id; }
  const r = push(ref(database, `${CMA_DRAFTS}/${uid}`));
  await set(r, { ...body, createdAt: now });
  return r.key;
};
export const deleteCmaDraft = (ownerUid, id) => remove(ref(database, `${CMA_DRAFTS}/${ownerUid}/${id}`));

// Agents: only their own. Admins: everyone's.
export const watchCmaDrafts = (uid, isAdmin, cb) => {
  if (!uid) { cb([]); return () => {}; }
  if (isAdmin) {
    return onValue(ref(database, CMA_DRAFTS), (s) => {
      const all = [];
      Object.entries(s.val() || {}).forEach(([owner, items]) => Object.entries(items || {}).forEach(([id, v]) => all.push({ id, ...v, ownerUid: owner })));
      cb(all.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0)));
    }, () => cb([]));
  }
  return onValue(ref(database, `${CMA_DRAFTS}/${uid}`), (s) => {
    cb(Object.entries(s.val() || {}).map(([id, v]) => ({ id, ...v, ownerUid: uid })).sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0)));
  }, () => cb([]));
};
